import React, { useState } from 'react';

const API = 'https://api.pixventa.com';

const S = {
  page:      { minHeight:'100vh', background:'#F5F6FA', display:'flex', alignItems:'center', justifyContent:'center' },
  card:      { background:'white', borderRadius:20, padding:36, width:380, boxShadow:'0 4px 24px rgba(0,0,0,0.08)', border:'1px solid #E4EDE8' },
  logo:      { textAlign:'center', fontSize:24, fontWeight:800, color:'#0D1F1A', marginBottom:6 },
  logoSpan:  { color:'#075E54' },
  sub:       { textAlign:'center', fontSize:13, color:'#7A8F89', marginBottom:28 },
  field:     { marginBottom:16 },
  label:     { display:'block', fontSize:11, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:6 },
  input:     { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:12, padding:'11px 14px', fontSize:14, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box' },
  btn:       { width:'100%', background:'linear-gradient(135deg,#075E54,#128C7E)', color:'white', border:'none', borderRadius:12, padding:14, fontSize:15, fontWeight:700, cursor:'pointer', fontFamily:'inherit', marginTop:8 },
  btnGray:   { width:'100%', background:'#F0F4F0', color:'#7A8F89', border:'1px solid #E4EDE8', borderRadius:12, padding:14, fontSize:14, cursor:'pointer', fontFamily:'inherit', marginTop:8 },
  error:     { background:'#FCEBEB', border:'1px solid #F09595', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#A32D2D', marginBottom:16, textAlign:'center' },
  success:   { background:'#E1F5EE', border:'1px solid #5DCAA5', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#085041', marginBottom:16, textAlign:'center' },
  footer:    { textAlign:'center', fontSize:11, color:'#7A8F89', marginTop:20 },
  otpWrap:   { display:'flex', gap:8, justifyContent:'center', margin:'8px 0 16px' },
  otpInput:  { width:44, height:52, textAlign:'center', fontSize:22, fontWeight:700, background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, outline:'none', fontFamily:'inherit', color:'#0D1F1A' },
  otpInputActive: { borderColor:'#075E54' },
  badge2fa:  { display:'flex', alignItems:'center', justifyContent:'center', gap:6, background:'#E1F5EE', border:'1px solid #5DCAA5', borderRadius:10, padding:'8px 14px', fontSize:12, color:'#085041', marginBottom:20 },
};

export default function Login({ onLogin }) {
  const [paso,      setPaso]      = useState('login'); // 'login' | '2fa'
  const [usuario,   setUsuario]   = useState('');
  const [password,  setPassword]  = useState('');
  const [error,     setError]     = useState('');
  const [cargando,  setCargando]  = useState(false);
  const [userData,  setUserData]  = useState(null);
  const [otp,       setOtp]       = useState(['','','','','','']);

  // ── Paso 1: Login ──
  async function handleLogin() {
    if (!usuario.trim() || !password.trim()) { setError('Completa usuario y contraseña'); return; }
    setCargando(true);
    try {
      const res  = await fetch(`${API}/admin/login`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ usuario, password }),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) { setError('Usuario o contraseña incorrectos'); return; }

      // Verificar si tiene 2FA activo
      const status = await fetch(`${API}/admin/2fa/status/${data.usuario.id}`);
      const s2fa   = await status.json();

      if (s2fa.activo) {
        setUserData(data.usuario);
        setPaso('2fa');
        setError('');
      } else {
        localStorage.setItem('wm_admin_auth', 'true');
        localStorage.setItem('wm_admin_user', JSON.stringify(data.usuario));
        onLogin();
      }
    } catch (err) {
      setError('Error de conexión. Intenta de nuevo.');
    } finally {
      setCargando(false);
    }
  }

  // ── Paso 2: Verificar 2FA ──
  async function handle2FA() {
    const token = otp.join('');
    if (token.length !== 6) { setError('Ingresa el código de 6 dígitos'); return; }
    setCargando(true);
    try {
      const res  = await fetch(`${API}/admin/2fa/verify/${userData.id}`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ token }),
      });
      const data = await res.json();
      if (!data.ok) { setError('Código incorrecto. Intenta de nuevo.'); setOtp(['','','','','','']); return; }
      localStorage.setItem('wm_admin_auth', 'true');
      localStorage.setItem('wm_admin_user', JSON.stringify(userData));
      onLogin();
    } catch (err) {
      setError('Error de conexión. Intenta de nuevo.');
    } finally {
      setCargando(false);
    }
  }

  // OTP input handler — avanza automáticamente al siguiente campo
  function handleOtp(index, value) {
    if (!/^\d*$/.test(value)) return;
    const nuevo = [...otp];
    nuevo[index] = value.slice(-1);
    setOtp(nuevo);
    setError('');
    if (value && index < 5) {
      document.getElementById(`otp-${index+1}`)?.focus();
    }
    if (nuevo.every(d => d !== '') && nuevo.join('').length === 6) {
      setTimeout(() => handle2FAWithToken(nuevo.join('')), 100);
    }
  }

  function handleOtpKeyDown(index, e) {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-${index-1}`)?.focus();
    }
    if (e.key === 'Enter') handle2FA();
  }

  async function handle2FAWithToken(token) {
    setCargando(true);
    try {
      const res  = await fetch(`${API}/admin/2fa/verify/${userData.id}`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ token }),
      });
      const data = await res.json();
      if (!data.ok) { setError('Código incorrecto. Intenta de nuevo.'); setOtp(['','','','','','']); return; }
      localStorage.setItem('wm_admin_auth', 'true');
      localStorage.setItem('wm_admin_user', JSON.stringify(userData));
      onLogin();
    } catch (err) {
      setError('Error de conexión.');
    } finally {
      setCargando(false);
    }
  }

  return (
    <div style={S.page}>
      <div style={S.card}>

        <div style={S.logo}><span style={S.logoSpan}>Pix</span>Venta</div>
        <div style={S.sub}>{paso === 'login' ? 'Panel de administración' : 'Verificación en dos pasos'}</div>

        {error && <div style={S.error}>⚠️ {error}</div>}

        {/* ── Paso 1: Login ── */}
        {paso === 'login' && (
          <>
            <div style={S.field}>
              <label style={S.label}>Usuario o Email</label>
              <input style={S.input} placeholder="admin@pixventa.com" value={usuario}
                onChange={e => { setUsuario(e.target.value); setError(''); }}
                onKeyDown={e => e.key==='Enter' && handleLogin()} autoFocus />
            </div>
            <div style={S.field}>
              <label style={S.label}>Contraseña</label>
              <input style={S.input} type="password" placeholder="••••••••" value={password}
                onChange={e => { setPassword(e.target.value); setError(''); }}
                onKeyDown={e => e.key==='Enter' && handleLogin()} />
            </div>
            <button style={{ ...S.btn, opacity: cargando?0.7:1 }} onClick={handleLogin} disabled={cargando}>
              {cargando ? '⏳ Verificando...' : '→ Entrar'}
            </button>
          </>
        )}

        {/* ── Paso 2: 2FA ── */}
        {paso === '2fa' && (
          <>
            <div style={S.badge2fa}>
              🔐 Abre Google Authenticator e ingresa el código
            </div>
            <div style={S.otpWrap}>
              {otp.map((digit, i) => (
                <input
                  key={i}
                  id={`otp-${i}`}
                  style={{ ...S.otpInput, ...(document.activeElement?.id===`otp-${i}` ? S.otpInputActive : {}) }}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={e => handleOtp(i, e.target.value)}
                  onKeyDown={e => handleOtpKeyDown(i, e)}
                  autoFocus={i === 0}
                />
              ))}
            </div>
            <button style={{ ...S.btn, opacity: cargando?0.7:1 }} onClick={handle2FA} disabled={cargando}>
              {cargando ? '⏳ Verificando...' : '✓ Verificar código'}
            </button>
            <button style={S.btnGray} onClick={() => { setPaso('login'); setOtp(['','','','','','']); setError(''); }}>
              ← Regresar
            </button>
          </>
        )}

        <div style={S.footer}>ctrl.pixventa.com</div>
      </div>
    </div>
  );
}